//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Articles from "./search/Articles.vue";
import Videos from "./search/Videos";
import Categories from "./search/Categories.vue";
import Products from "./search/Products.vue";
import Specialists from "./search/Specialists.vue";
import Service from "./search/Service.vue";
import Questions from './search/Questions.vue'

export default {
  name: "DialogSearch",
  emits: ["open", "close"],
  data: function () {
    return {
      headers: [],
      sections: [],

      activeCategory: "",
      search: "",

      totalSearchCount: 0,

      isLoading: false,

      deferredSearch: null,
    };
  },
  components: {
    Service,
    Products,
    Articles,
    Categories,
    Specialists,
    Videos,
    Questions
  },
  mounted() {
    this.$refs.refInput.focus();
  },
  methods: {
    onClose() {
      this.$emit('close');
    },
    onChangeSearch: async function ({target}) {
      this.search = target.value;

      clearTimeout(this.deferredSearch);

      if (!target.value || target.value.length < 3) {
        return null;
      }

      this.deferredSearch = setTimeout(async () => {
        await this.getContent();
      }, 500);
    },
    getContent: async function () {
      this.isLoading = true;

      const {data: response} = await this.$api.agent.transport.get(
        `catalog/search?query=${this.search}`
      );
      const content = response?.results || {};

      const totalCount = Object.keys(content || {}).reduce((prev, current) => {
        return prev + (content[current]?.items || []).length;
      }, 0);

      // Сборка поиска (HEADER)
      let headers = [
        {id: "", title: "Все результаты", value: totalCount},
      ];
      Object.keys(content || {}).map((key, index) => {
        const item = content[key];

        if (key !== 'filter_pages') {
          headers.push({
            id: index + 1,
            title: item.name,
            value: (content?.[key]?.items || []).length
          })
        }
        if (key === 'filter_pages') {
          (item?.items || []).map((itemChild, indexChild) => {
            headers.push({
              id: index + 1 + 100,
              title: itemChild.title,
              value: itemChild.products_count,
              url: itemChild.url
            });
          });
        }
      })

      let sections = [];
      Object.keys(content || {}).map((key, index) => {
        const item = content[key];

        sections.push({
          id: index + 1,
          title: item.name,
          type: key,
          length: (content?.[key]?.items || []).length,
          items: content?.[key]?.items,
        })
      });


      // Замена ссылок для filter_pages category 3
      sections = sections.map((section) => {
        const items = Boolean(section?.type !== 'filter_pages') ? section?.items : (section?.items || []).map((item) => {
          const url = Boolean(item?.category_id === 3) ? `/ochki/${item.slug}` : item.url;

          return {
            ...item,
            url
          }
        });
        return {
          ...section,
          items
        }
      });

      this.headers = headers;
      this.sections = sections;
      this.totalSearchCount = totalCount;

      this.isLoading = false;
    },

    goPageSearch: function () {

      // Если поиск меньше 3 симовлов, то переход отменен
      if (this.search.length < 3) {
        return null
      }

      this.onClose();

      this.$router.push(`/search?search=${this.search}`);
    },
  },
};
